


























































import Vue from "vue";
import Component from "vue-class-component";

import Row from "@/components/layout/Row.vue";
import Column from "@/components/layout/Column.vue";

@Component<TabbedCard>({
  components: {
    Row,
    Column
  },
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "primary"
    },
    icon: {
      type: String,
      default: ""
    },
    borderRadius: {
      type: Number,
      default: 20
    },
    titleMargin: {
      type: Number,
      default: 0
    },
    error: {
      type: String,
      default: ""
    },
    small: {
      type: Boolean,
      default: false
    },
    activeTabIndex: {
      type: Number,
      default: 0,
      required: true
    }
  }
})
export default class TabbedCard extends Vue {
  private get totalBorderRadius() {
    return this.$props.borderRadius + "px !important";
  }

  private get topBorderRadius() {
    const radius = this.$props.borderRadius;
    return `${radius}px ${radius}px 0px 0px`;
  }

  private get bottomBorderRadius() {
    const radius = this.$props.borderRadius;
    return `0px 0px ${radius}px ${radius}px`;
  }

  private get margin() {
    return this.$props.titleMargin + "px !important";
  }
}
